export const stateOptions = [
  { codeValue: 'AL', shortName: 'Alabama' },
  { codeValue: 'AK', shortName: 'Alaska' },
  { codeValue: 'AZ', shortName: 'Arizona' },
  { codeValue: 'AR', shortName: 'Arkansas' },
  { codeValue: 'CA', shortName: 'California' },
  { codeValue: 'CO', shortName: 'Colorado' },
  { codeValue: 'CT', shortName: 'Connecticut' },
  { codeValue: 'DE', shortName: 'Delaware' },
  { codeValue: 'DC', shortName: 'District of Columbia' },
  { codeValue: 'FL', shortName: 'Florida' },
  { codeValue: 'GA', shortName: 'Georgia' },
  { codeValue: 'HI', shortName: 'Hawaii' },
  { codeValue: 'ID', shortName: 'Idaho' },
  { codeValue: 'IL', shortName: 'Illinois' },
  { codeValue: 'IN', shortName: 'Indiana' },
  { codeValue: 'IA', shortName: 'Iowa' },
  { codeValue: 'KS', shortName: 'Kansas' },
  { codeValue: 'KY', shortName: 'Kentucky' },
  { codeValue: 'LA', shortName: 'Louisiana' },
  { codeValue: 'ME', shortName: 'Maine' },
  { codeValue: 'MD', shortName: 'Maryland' },
  { codeValue: 'MA', shortName: 'Massachusetts' },
  { codeValue: 'MI', shortName: 'Michigan' },
  { codeValue: 'MN', shortName: 'Minnesota' },
  { codeValue: 'MS', shortName: 'Mississippi' },
  { codeValue: 'MO', shortName: 'Missouri' },
  { codeValue: 'MT', shortName: 'Montana' },
  { codeValue: 'NE', shortName: 'Nebraska' },
  { codeValue: 'NV', shortName: 'Nevada' },
  { codeValue: 'NH', shortName: 'New Hampshire' },
  { codeValue: 'NJ', shortName: 'New Jersey' },
  { codeValue: 'NM', shortName: 'New Mexico' },
  { codeValue: 'NY', shortName: 'New York' },
  { codeValue: 'NC', shortName: 'North Carolina' },
  { codeValue: 'ND', shortName: 'North Dakota' },
  { codeValue: 'OH', shortName: 'Ohio' },
  { codeValue: 'OK', shortName: 'Oklahoma' },
  { codeValue: 'OR', shortName: 'Oregon' },
  { codeValue: 'PA', shortName: 'Pennsylvania' },
  { codeValue: 'PR', shortName: 'Puerto Rico' },
  { codeValue: 'RI', shortName: 'Rhode Island' },
  { codeValue: 'SC', shortName: 'South Carolina' },
  { codeValue: 'SD', shortName: 'South Dakota' },
  { codeValue: 'TN', shortName: 'Tennessee' },
  { codeValue: 'TX', shortName: 'Texas' },
  { codeValue: 'UT', shortName: 'Utah' },
  { codeValue: 'VT', shortName: 'Vermont' },
  { codeValue: 'VA', shortName: 'Virginia' },
  { codeValue: 'WA', shortName: 'Washington' },
  { codeValue: 'WV', shortName: 'West Virginia' },
  { codeValue: 'WI', shortName: 'Wisconsin' },
  { codeValue: 'WY', shortName: 'Wyoming' },
];

export const COUNTRY_OPTIONS = [
  {
    codeValue: 'AFG',
    shortName: 'Afghanistan',
  },
  {
    codeValue: 'ALB',
    shortName: 'Albania',
  },
  {
    codeValue: 'DZA',
    shortName: 'Algeria',
  },
  {
    codeValue: 'AND',
    shortName: 'Andorra',
  },
  {
    codeValue: 'AGO',
    shortName: 'Angola',
  },
  {
    codeValue: 'ATG',
    shortName: 'Antigua and Barbuda',
  },
  {
    codeValue: 'ARG',
    shortName: 'Argentina',
  },
  {
    codeValue: 'ARM',
    shortName: 'Armenia',
  },
  {
    codeValue: 'AUS',
    shortName: 'Australia',
  },
  {
    codeValue: 'AUT',
    shortName: 'Austria',
  },
  {
    codeValue: 'AZE',
    shortName: 'Azerbaijan',
  },
  {
    codeValue: 'BHS',
    shortName: 'Bahamas',
  },
  {
    codeValue: 'BHR',
    shortName: 'Bahrain',
  },
  {
    codeValue: 'BGD',
    shortName: 'Bangladesh',
  },
  {
    codeValue: 'BRB',
    shortName: 'Barbados',
  },
  {
    codeValue: 'BLR',
    shortName: 'Belarus',
  },
  {
    codeValue: 'BEL',
    shortName: 'Belgium',
  },
  {
    codeValue: 'BLZ',
    shortName: 'Belize',
  },
  {
    codeValue: 'BEN',
    shortName: 'Benin',
  },
  {
    codeValue: 'BTN',
    shortName: 'Bhutan',
  },
  {
    codeValue: 'BOL',
    shortName: 'Bolivia, Plurinational State of',
  },
  {
    codeValue: 'BIH',
    shortName: 'Bosnia and Herzegovina',
  },
  {
    codeValue: 'BWA',
    shortName: 'Botswana',
  },
  {
    codeValue: 'BRA',
    shortName: 'Brazil',
  },
  {
    codeValue: 'BRN',
    shortName: 'Brunei',
  },
  {
    codeValue: 'BGR',
    shortName: 'Bulgaria',
  },
  {
    codeValue: 'BFA',
    shortName: 'Burkina Faso',
  },
  {
    codeValue: 'MMR',
    shortName: 'Burma (Myanmar)',
  },
  {
    codeValue: 'BDI',
    shortName: 'Burundi',
  },
  {
    codeValue: 'KHM',
    shortName: 'Cambodia',
  },
  {
    codeValue: 'CMR',
    shortName: 'Cameroon',
  },
  {
    codeValue: 'CAN',
    shortName: 'Canada',
  },
  {
    codeValue: 'CPV',
    shortName: 'Cape Verde',
  },
  {
    codeValue: 'CAF',
    shortName: 'Central African Republic',
  },
  {
    codeValue: 'TCD',
    shortName: 'Chad',
  },
  {
    codeValue: 'CHL',
    shortName: 'Chile',
  },
  {
    codeValue: 'CHN',
    shortName: 'China',
  },
  {
    codeValue: 'COL',
    shortName: 'Colombia',
  },
  {
    codeValue: 'COM',
    shortName: 'Comoros',
  },
  {
    codeValue: 'COD',
    shortName: 'Congo, Democratic Republic of the',
  },
  {
    codeValue: 'COG',
    shortName: 'Congo, Republic of the',
  },
  {
    codeValue: 'CRI',
    shortName: 'Costa Rica',
  },
  {
    codeValue: 'CIV',
    shortName: "Cote d'Ivoire (Ivory Coast)",
  },
  {
    codeValue: 'HRV',
    shortName: 'Croatia',
  },
  {
    codeValue: 'CUB',
    shortName: 'Cuba',
  },
  {
    codeValue: 'CYP',
    shortName: 'Cyprus',
  },
  {
    codeValue: 'CZE',
    shortName: 'Czech Republic',
  },
  {
    codeValue: 'DNK',
    shortName: 'Denmark',
  },
  {
    codeValue: 'DJI',
    shortName: 'Djibouti',
  },
  {
    codeValue: 'DMA',
    shortName: 'Dominica',
  },
  {
    codeValue: 'DOM',
    shortName: 'Dominican Republic',
  },
  {
    codeValue: 'ECU',
    shortName: 'Ecuador',
  },
  {
    codeValue: 'EGY',
    shortName: 'Egypt',
  },
  {
    codeValue: 'SLV',
    shortName: 'El Salvador',
  },
  {
    codeValue: 'GNQ',
    shortName: 'Equatorial Guinea',
  },
  {
    codeValue: 'ERI',
    shortName: 'Eritrea',
  },
  {
    codeValue: 'EST',
    shortName: 'Estonia',
  },
  {
    codeValue: 'SWZ',
    shortName: 'Eswatini',
  },
  {
    codeValue: 'ETH',
    shortName: 'Ethiopia',
  },
  {
    codeValue: 'FJI',
    shortName: 'Fiji',
  },
  {
    codeValue: 'FIN',
    shortName: 'Finland',
  },
  {
    codeValue: 'FRA',
    shortName: 'France',
  },
  {
    codeValue: 'GAB',
    shortName: 'Gabon',
  },
  {
    codeValue: 'GMB',
    shortName: 'Gambia',
  },
  {
    codeValue: 'GEO',
    shortName: 'Georgia',
  },
  {
    codeValue: 'DEU',
    shortName: 'Germany',
  },
  {
    codeValue: 'GHA',
    shortName: 'Ghana',
  },
  {
    codeValue: 'GRC',
    shortName: 'Greece',
  },
  {
    codeValue: 'GRD',
    shortName: 'Grenada',
  },
  {
    codeValue: 'GTM',
    shortName: 'Guatemala',
  },
  {
    codeValue: 'GIN',
    shortName: 'Guinea',
  },
  {
    codeValue: 'GNB',
    shortName: 'Guinea-Bissau',
  },
  {
    codeValue: 'GUY',
    shortName: 'Guyana',
  },
  {
    codeValue: 'HTI',
    shortName: 'Haiti',
  },
  {
    codeValue: 'VAT',
    shortName: 'Holy See (Vatican City State)',
  },
  {
    codeValue: 'HND',
    shortName: 'Honduras',
  },
  {
    codeValue: 'HKG',
    shortName: 'Hong Kong',
  },
  {
    codeValue: 'HUN',
    shortName: 'Hungary',
  },
  {
    codeValue: 'ISL',
    shortName: 'Iceland',
  },
  {
    codeValue: 'IND',
    shortName: 'India',
  },
  {
    codeValue: 'IDN',
    shortName: 'Indonesia',
  },
  {
    codeValue: 'IRN',
    shortName: 'Iran, Islamic Republic of',
  },
  {
    codeValue: 'IRQ',
    shortName: 'Iraq',
  },
  {
    codeValue: 'IRL',
    shortName: 'Ireland',
  },
  {
    codeValue: 'ISR',
    shortName: 'Israel',
  },
  {
    codeValue: 'ITA',
    shortName: 'Italy',
  },
  {
    codeValue: 'JAM',
    shortName: 'Jamaica',
  },
  {
    codeValue: 'JPN',
    shortName: 'Japan',
  },
  {
    codeValue: 'JOR',
    shortName: 'Jordan',
  },
  {
    codeValue: 'KAZ',
    shortName: 'Kazakhstan',
  },
  {
    codeValue: 'KEN',
    shortName: 'Kenya',
  },
  {
    codeValue: 'KIR',
    shortName: 'Kiribati',
  },
  {
    codeValue: 'PRK',
    shortName: 'Korea, Democratic Republic of (North)',
  },
  {
    codeValue: 'KOR',
    shortName: 'Korea, Republic of (South)',
  },
  {
    codeValue: 'XKS',
    shortName: 'Kosovo',
  },
  {
    codeValue: 'KWT',
    shortName: 'Kuwait',
  },
  {
    codeValue: 'KGZ',
    shortName: 'Kyrgyzstan',
  },
  {
    codeValue: 'LAO',
    shortName: 'Laos',
  },
  {
    codeValue: 'LVA',
    shortName: 'Latvia',
  },
  {
    codeValue: 'LBN',
    shortName: 'Lebanon',
  },
  {
    codeValue: 'LSO',
    shortName: 'Lesotho',
  },
  {
    codeValue: 'LBR',
    shortName: 'Liberia',
  },
  {
    codeValue: 'LBY',
    shortName: 'Libya',
  },
  {
    codeValue: 'LIE',
    shortName: 'Liechtenstein',
  },
  {
    codeValue: 'LTU',
    shortName: 'Lithuania',
  },
  {
    codeValue: 'LUX',
    shortName: 'Luxembourg',
  },
  {
    codeValue: 'MKD',
    shortName: 'Macedonia, the Former Yugoslav Republic of',
  },
  {
    codeValue: 'MDG',
    shortName: 'Madagascar',
  },
  {
    codeValue: 'MWI',
    shortName: 'Malawi',
  },
  {
    codeValue: 'MYS',
    shortName: 'Malaysia',
  },
  {
    codeValue: 'MDV',
    shortName: 'Maldives',
  },
  {
    codeValue: 'MLI',
    shortName: 'Mali',
  },
  {
    codeValue: 'MLT',
    shortName: 'Malta',
  },
  {
    codeValue: 'MHL',
    shortName: 'Marshall Islands, Republic of the',
  },
  {
    codeValue: 'MRT',
    shortName: 'Mauritania',
  },
  {
    codeValue: 'MUS',
    shortName: 'Mauritius',
  },
  {
    codeValue: 'MEX',
    shortName: 'Mexico',
  },
  {
    codeValue: 'FSM',
    shortName: 'Micronesia, Federated States of',
  },
  {
    codeValue: 'MDA',
    shortName: 'Moldova, Republic of',
  },
  {
    codeValue: 'MCO',
    shortName: 'Monaco',
  },
  {
    codeValue: 'MNG',
    shortName: 'Mongolia',
  },
  {
    codeValue: 'MNE',
    shortName: 'Montenegro',
  },
  {
    codeValue: 'MAR',
    shortName: 'Morocco',
  },
  {
    codeValue: 'MOZ',
    shortName: 'Mozambique',
  },
  {
    codeValue: 'NAM',
    shortName: 'Namibia',
  },
  {
    codeValue: 'NRU',
    shortName: 'Nauru',
  },
  {
    codeValue: 'NPL',
    shortName: 'Nepal',
  },
  {
    codeValue: 'NLD',
    shortName: 'Netherlands',
  },
  {
    codeValue: 'NZL',
    shortName: 'New Zealand',
  },
  {
    codeValue: 'NIC',
    shortName: 'Nicaragua',
  },
  {
    codeValue: 'NER',
    shortName: 'Niger',
  },
  {
    codeValue: 'NGA',
    shortName: 'Nigeria',
  },
  {
    codeValue: 'NOR',
    shortName: 'Norway',
  },
  {
    codeValue: 'OMN',
    shortName: 'Oman',
  },
  {
    codeValue: 'PAK',
    shortName: 'Pakistan',
  },
  {
    codeValue: 'PLW',
    shortName: 'Palau',
  },
  {
    codeValue: 'PSE',
    shortName: 'Palestine',
  },
  {
    codeValue: 'PAN',
    shortName: 'Panama',
  },
  {
    codeValue: 'PNG',
    shortName: 'Papua New Guinea',
  },
  {
    codeValue: 'PRY',
    shortName: 'Paraguay',
  },
  {
    codeValue: 'PER',
    shortName: 'Peru',
  },
  {
    codeValue: 'PHL',
    shortName: 'Philippines',
  },
  {
    codeValue: 'POL',
    shortName: 'Poland',
  },
  {
    codeValue: 'PRT',
    shortName: 'Portugal',
  },
  {
    codeValue: 'QAT',
    shortName: 'Qatar',
  },
  {
    codeValue: 'ROU',
    shortName: 'Romania',
  },
  {
    codeValue: 'RUS',
    shortName: 'Russia',
  },
  {
    codeValue: 'RWA',
    shortName: 'Rwanda',
  },
  {
    codeValue: 'KNA',
    shortName: 'Saint Kitts and Nevis',
  },
  {
    codeValue: 'LCA',
    shortName: 'Saint Lucia',
  },
  {
    codeValue: 'VCT',
    shortName: 'Saint Vincent and the Grenadines',
  },
  {
    codeValue: 'WSM',
    shortName: 'Samoa',
  },
  {
    codeValue: 'SMR',
    shortName: 'San Marino',
  },
  {
    codeValue: 'STP',
    shortName: 'Sao Tome and Principe',
  },
  {
    codeValue: 'SAU',
    shortName: 'Saudi Arabia',
  },
  {
    codeValue: 'SEN',
    shortName: 'Senegal',
  },
  {
    codeValue: 'SRB',
    shortName: 'Serbia',
  },
  {
    codeValue: 'SYC',
    shortName: 'Seychelles',
  },
  {
    codeValue: 'SLE',
    shortName: 'Sierra Leone',
  },
  {
    codeValue: 'SGP',
    shortName: 'Singapore',
  },
  {
    codeValue: 'SVK',
    shortName: 'Slovakia',
  },
  {
    codeValue: 'SVN',
    shortName: 'Slovenia',
  },
  {
    codeValue: 'SLB',
    shortName: 'Solomon Islands',
  },
  {
    codeValue: 'SOM',
    shortName: 'Somalia',
  },
  {
    codeValue: 'ZAF',
    shortName: 'South Africa',
  },
  {
    codeValue: 'SSD',
    shortName: 'South Sudan',
  },
  {
    codeValue: 'ESP',
    shortName: 'Spain',
  },
  {
    codeValue: 'LKA',
    shortName: 'Sri Lanka',
  },
  {
    codeValue: 'SDN',
    shortName: 'Sudan',
  },
  {
    codeValue: 'SUR',
    shortName: 'Suriname',
  },
  {
    codeValue: 'SWE',
    shortName: 'Sweden',
  },
  {
    codeValue: 'CHE',
    shortName: 'Switzerland',
  },
  {
    codeValue: 'SYR',
    shortName: 'Syria',
  },
  {
    codeValue: 'TWN',
    shortName: 'Taiwan',
  },
  {
    codeValue: 'TJK',
    shortName: 'Tajikistan',
  },
  {
    codeValue: 'TZA',
    shortName: 'Tanzania, United Republic of',
  },
  {
    codeValue: 'THA',
    shortName: 'Thailand',
  },
  {
    codeValue: 'TLS',
    shortName: 'Timor-leste',
  },
  {
    codeValue: 'TGO',
    shortName: 'Togo',
  },
  {
    codeValue: 'TON',
    shortName: 'Tonga',
  },
  {
    codeValue: 'TTO',
    shortName: 'Trinidad and Tobago',
  },
  {
    codeValue: 'TUN',
    shortName: 'Tunisia',
  },
  {
    codeValue: 'TUR',
    shortName: 'Turkey',
  },
  {
    codeValue: 'TKM',
    shortName: 'Turkmenistan',
  },
  {
    codeValue: 'TUV',
    shortName: 'Tuvalu',
  },
  {
    codeValue: 'UGA',
    shortName: 'Uganda',
  },
  {
    codeValue: 'UKR',
    shortName: 'Ukraine',
  },
  {
    codeValue: 'ARE',
    shortName: 'United Arab Emirates',
  },
  {
    codeValue: 'GBR',
    shortName: 'United Kingdom',
  },
  {
    codeValue: 'URY',
    shortName: 'Uruguay',
  },
  {
    codeValue: 'UZB',
    shortName: 'Uzbekistan',
  },
  {
    codeValue: 'VUT',
    shortName: 'Vanuatu',
  },
  {
    codeValue: 'VEN',
    shortName: 'Venezuela, Bolivarian Republic of',
  },
  {
    codeValue: 'VNM',
    shortName: 'Viet Nam',
  },
  {
    codeValue: 'YEM',
    shortName: 'Yemen',
  },
  {
    codeValue: 'ZMB',
    shortName: 'Zambia',
  },
  {
    codeValue: 'ZWE',
    shortName: 'Zimbabwe',
  },
];

export const STEPS = {
  notice: 'notice', // pre-Section 1 notice acknowledgment
  step0: 'step0', // welcome
  step1: 'step1', // i9 personal info
  step2: 'step2', // i9 resident status
  step3: 'step3', // i9 preview
  step4: 'step4', // signing
};

export const step1Questions = [
  {
    id: 'first_name',
    title: 'First Name',
    question_type: 'short_text',
    is_required: true,
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: "^[a-zA-Z'’\\- ]{1,25}$",
        customErrorMessage:
          'First name can have up to 25 characters, and can only contain letters, apostrophes, hyphens, and spaces.',
      },
    ],
  },
  {
    id: 'middle_initial',
    title: 'Middle Initial',
    is_required: false,
    question_type: 'short_text',
    placeholder: 'The first letter of the middle name.',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^[a-zA-Z]{1}$',
        customErrorMessage: 'The middle initial can only contain 1 letter.',
      },
    ],
  },
  {
    id: 'last_name',
    title: 'Last Name',
    question_type: 'short_text',
    is_required: true,
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: "^[a-zA-Z'’\\- ]{1,40}$",
        customErrorMessage:
          'Last name can have up to 40 characters, and can only contain letters, apostrophes, hyphens, and spaces.',
      },
    ],
  },
  {
    id: 'other_last_names_used',
    title: 'Other Last Names Used',
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: "^[a-zA-Z'’\\- ]*$",
        customErrorMessage:
          'The other last names used can only contain letters, apostrophes, hyphens, and spaces.',
      },
    ],
  },
  {
    id: 'address',
    title: 'Address (Street Number and Name)',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'apt_number',
    title: 'Apt. Number',
    is_required: false,
    question_type: 'short_text',
  },
  {
    id: 'city_or_town',
    title: 'City or Town',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'state',
    title: 'State',
    is_required: true,
    question_type: 'dropdown',
    options: stateOptions,
  },
  {
    id: 'zip_code',
    title: 'ZIP Code',
    is_required: true,
    question_type: 'short_text',
    placeholder: '5 digits',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{5,6}$',
      },
    ],
  },
  {
    id: 'date_of_birth',
    title: 'Date of Birth',
    is_required: true,
    question_type: 'date',
    dateFormat: 'MM/DD/YYYY',
  },
  {
    id: 'social_security_number',
    title: 'U.S Social Security Number',
    is_required: true,
    placeholder: '9 digits',
    question_type: 'ssn',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(?!123456789|111111111)\\d{9}$',
        customErrorMessage: 'The SSN must have exactly 9 digits, and cannot be 111111111 or 123456789',
      },
    ],
  },
  {
    id: 'email_address',
    title: 'Employee\'s Email Address',
    is_required: false,
    question_type: 'email',
  },
  {
    id: 'phone_number',
    title: 'Employee\'s Telephone Number',
    is_required: false,
    question_type: 'us_telephone',
  },
];

export const residentStatusQuestion = {
  id: 'resident_status_code',
  title: 'I attest, under penalty of perjury, that I am:',
  is_required: true,
  question_type: 'multiple_choice',
  options: [
    {
      codeValue: 'citizen',
      shortName: 'A citizen of the United States',
    },
    {
      codeValue: 'noncitizen_national',
      shortName: 'A noncitizen national of the United States',
    },
    {
      codeValue: 'lawful_permanent_resident',
      shortName: 'A lawful permanent resident',
    },
    {
      codeValue: 'alien_authorized_to_work',
      shortName: 'An alien authorized to work',
    },
  ],
};

export const residentStatusQuestion2022 = {
  id: 'resident_status_code',
  title: 'I attest, under penalty of perjury, that I am:',
  is_required: true,
  question_type: 'multiple_choice',
  options: [
    {
      codeValue: 'citizen',
      shortName: 'A citizen of the United States',
    },
    {
      codeValue: 'noncitizen_national',
      shortName: 'A noncitizen national of the United States',
    },
    {
      codeValue: 'lawful_permanent_resident',
      shortName: 'A lawful permanent resident',
    },
    {
      codeValue: 'alien_authorized_to_work',
      shortName: 'An alien authorized to work',
    },
  ],
};

export const alienCodeQuestion = {
  id: 'alien_code',
  title:
    'Please select which work authorization you have and provide your USCIS A-Number, Form I-94 Admission Number, or Foreign Passport Number',
  is_required: true,
  question_type: 'multiple_choice',
  options: [
    {
      codeValue: '1',
      shortName: 'USCIS A-Number',
    },
    {
      codeValue: '2',
      shortName: 'Form I-94 Admission Number',
    },
    {
      codeValue: '3',
      shortName: 'Foreign Passport Number',
    },
  ],
};

export const alienCodeQuestion2022 = {
  id: 'alien_code',
  title:
    'Please select which work authorization you have and provide your Alien Registration Number/USCIS Number, Form I-94 Admission Number, or Foreign Passport Number',
  is_required: true,
  question_type: 'multiple_choice',
  options: [
    {
      codeValue: '1',
      shortName: 'Alien Registration Number/USCIS Number',
    },
    {
      codeValue: '2',
      shortName: 'Form I-94 Admission Number',
    },
    {
      codeValue: '3',
      shortName: 'Foreign Passport Number',
    },
  ],
};

export const lawfulNumberQuestion = {
  id: 'lawful_permanent_resident_alien_registration_or_uscis_number',
  title: 'USCIS A-Number',
  is_required: true,
  question_type: 'alien_registration_number',
  placeholder: 'A - (9 digits)',
  additional_note:
    'Must be exactly 9 digits [0-9] except "A". Please add leading zeroes if number on document is less than 9 digits.',
  rules: [
    {
      category: 'regex',
      action: 'match',
      value: '^A\\d{9}$',
      customErrorMessage: 'Must be exactly 9 digits. Prefix number with 0 if it is shorter.',
    },
  ],
};

export const lawfulNumberQuestion2022 = {
  id: 'lawful_permanent_resident_alien_registration_or_uscis_number',
  title: 'Alien Registration Number/USCIS Number',
  is_required: true,
  question_type: 'alien_registration_number',
  placeholder: 'A - (9 digits)',
  additional_note:
    'Must be exactly 9 digits [0-9] except "A". Please add leading zeroes if number on document is less than 9 digits.',
  rules: [
    {
      category: 'regex',
      action: 'match',
      value: '^A\\d{9}$',
      customErrorMessage: 'Must be exactly 9 digits. Prefix number with 0 if it is shorter.',
    },
  ],
};

export const alienNumberQuestion = {
  id: 'alien_registration_or_uscis_number',
  title: 'USCIS A-Number',
  is_required: true,
  question_type: 'alien_registration_number',
  placeholder: 'A - (9 digits)',
  additional_note:
    'Must be exactly 9 digits [0-9] except "A". Please add leading zeroes if number on document is less than 9 digits.',
  rules: [
    {
      category: 'regex',
      action: 'match',
      value: '^A\\d{9}$',
      customErrorMessage: 'Must be exactly 9 digits. Prefix number with 0 if it is shorter.',
    },
  ],
};

export const alienNumberQuestion2022 = {
  id: 'alien_registration_or_uscis_number',
  title: 'Alien Registration Number/USCIS Number',
  is_required: true,
  question_type: 'alien_registration_number',
  placeholder: 'A - (9 digits)',
  additional_note:
    'Must be exactly 9 digits [0-9] except "A". Please add leading zeroes if number on document is less than 9 digits.',
  rules: [
    {
      category: 'regex',
      action: 'match',
      value: '^A\\d{9}$',
      customErrorMessage: 'Must be exactly 9 digits. Prefix number with 0 if it is shorter.',
    },
  ],
};

export const admissionNumberQuestion = {
  id: 'admission_number',
  title: 'Form I-94 Admission Number',
  is_required: true,
  question_type: 'short_text',
  rules: [
    {
      category: 'regex',
      action: 'match',
      value: '^[0-9A-Za-z]{11}$',
    },
  ],
};

export const foreignPassportQuestion = {
  id: 'passport_number',
  title: 'Foreign Passport Number',
  is_required: true,
  question_type: 'short_text',
};

export const alienCountryQuestion = {
  id: 'country_of_issuance',
  title: 'Country of Issuance',
  is_required: true,
  question_type: 'dropdown',
  options: COUNTRY_OPTIONS.map((s) => ({ codeValue: s.shortName, shortName: s.shortName })),
};

export const EMPLOYER_STEP = {
  step0: 'choose document',
  step2: 'fill document',
  step3: 'fill employer form',
  step4: 'review',
  step5: 'sign',
};

export const listADocumentsByCitizenshipStatus = {
  citizen: [
    {
      code: 'US_PASSPORT',
      name: 'U.S. Passport or Passport Card',
      abbr: 'U.S. Passport or Passport Card',
    },
  ],
  noncitizen_national: [
    {
      code: 'US_PASSPORT',
      name: 'U.S. Passport or Passport Card',
      abbr: 'U.S. Passport or Passport Card',
    },
  ],
  lawful_permanent_resident: [
    {
      code: 'FORM_I94_RECEIPT',
      name: 'Arrival/Departure Record (Form I-94) with temporary I-551 stamp or refugee admission stamp (receipt)',
      abbr: 'Arrival/Departure Record (Form I-94) with temporary I-551 stamp or refugee admission stamp (receipt)',
    },
    {
      code: 'FORM_I551',
      name: 'Permanent Resident Card or Alien Registration Receipt Card (Form I-551)',
      abbr: 'Permanent Resident Card or Alien Registration Receipt Card (Form I-551)',
    },
    {
      code: 'FOREIGN_PASSPORT_WITH_I551_STAMP',
      name: 'Foreign passport with temporary I-551 stamp or printed notation on a MRIV',
      abbr: 'Foreign passport with temporary I-551 stamp or printed notation on a MRIV',
    },
  ],
  alien_authorized_to_work: [
    {
      code: 'FORM_I94_RECEIPT',
      name: 'Arrival/Departure Record (Form I-94) with temporary I-551 stamp or refugee admission stamp (receipt)',
      abbr: 'Arrival/Departure Record (Form I-94) with temporary I-551 stamp or refugee admission stamp (receipt)',
    },
    {
      code: 'FORM_I766',
      name: 'Employment Authorization Document (Form I-766)',
      abbr: 'Employment Authorization Document (Form I-766)',
    },
    {
      code: 'FOREIGN_PASSPORT_WITH_FORM_I94',
      name: 'Foreign passport with Arrival/Departure Record (Form I-94)',
      abbr: 'Foreign passport with Arrival/Departure Record (Form I-94)',
    },
  ],
};

export const listBDocuments = [
  {
    code: 'DRIVERS_LICENSE',
    name: "Driver's license or ID card issued by a U.S. state or outlying possession",
    abbr: "Driver's license issued by state/territory",
  },
  {
    code: 'GOVERNMENT_ID_CARD',
    name: 'ID card issued by a U.S. federal, state or local government agency',
    abbr: 'Government ID',
  },
  {
    code: 'SCHOOL_ID_CARD',
    name: 'School ID card',
    abbr: 'School ID card',
  },
  {
    code: 'VOTER_REGISTRATION_CARD',
    name: 'Voter registration card',
    abbr: 'Voter registration card',
  },
  {
    code: 'US_MILITARY_CARD',
    name: 'U.S. military card or draft record',
    abbr: 'U.S. military card or draft record',
  },
  {
    code: 'MILITARY_DEPENDENT_ID_CARD',
    name: "Military dependent's ID card",
    abbr: "Military dependent's ID card",
  },
  {
    code: 'US_COAST_GUARD_CARD',
    name: 'U.S. Coast Guard Merchant Mariner Card',
    abbr: 'U.S. Coast Guard Merchant Mariner Card',
  },
  {
    code: 'CANADIAN_DRIVERS_LICENSE',
    name: "Driver's license issued by a Canadian government authority",
    abbr: "Driver's license issued by a Canadian government authority",
  },
  {
    code: 'SCHOOL_RECORD',
    name: 'School record or report card (under age 18)',
    abbr: 'School record or report card (under age 18)',
  },
  {
    code: 'HOSPITAL_RECORD',
    name: 'Clinic, doctor or hospital record (under age 18)',
    abbr: 'Clinic, doctor or hospital record (under age 18)',
  },
  {
    code: 'DAY_CARE_RECORD',
    name: 'Day-care or nursery school record (under age 18)',
    abbr: 'Day-care or nursery school record (under age 18)',
  },
  {
    code: 'NATIVE_AMERICAN_TRIBAL_DOCUMENT',
    name: 'Native American tribal document',
    abbr: 'Native American tribal document',
  },
];

export const listCDocumentsByCitizenshipStatus = {
  citizen: [
    {
      code: 'SOCIAL_SECURITY_CARD',
      name: 'Social Security Card',
      abbr: 'Social Security Card',
    },
    {
      code: 'FS_545',
      name: 'Certification of Birth Abroad (FS 545)',
      abbr: 'Form FS-545',
    },
    {
      code: 'DS_1350',
      name: 'Certificate of Report of Birth (DS 1350)',
      abbr: 'Form DS-1350',
    },
    {
      code: 'FS_240',
      name: 'Consular Report of Birth Abroad (FS 240)',
      abbr: 'Form FS-240',
    },
    {
      code: 'US_BIRTH_CERTIFICATE',
      name: 'U.S. birth certificate (original or certified copy)',
      abbr: 'Birth Certificate',
    },
    {
      code: 'NATIVE_AMERICAN_TRIBAL_DOCUMENT',
      name: 'Native American tribal document',
      abbr: 'Native American tribal document',
    },
    {
      code: 'FORM_I197',
      name: 'U.S. Citizen ID Card (Form I-197)',
      abbr: 'U.S. Citizen ID Card (Form I-197)',
    },
    {
      code: 'FORM_I179',
      name: 'ID Card for Use of Resident Citizen in the United States (Form I-179)',
      abbr: 'ID Card for Use of Resident Citizen in the United States (Form I-179)',
    },
    {
      code: 'EMPLOYMENT_AUTHORIZATION_DOCUMENT',
      name: 'Employment authorization document issued by the U.S. Department of Homeland Security',
      abbr: 'Employment authorization document issued by the U.S. Department of Homeland Security',
    },
  ],
  noncitizen_national: [
    {
      code: 'SOCIAL_SECURITY_CARD',
      name: 'Social Security Card',
      abbr: 'Social Security Card',
    },
    {
      code: 'FS_545',
      name: 'Certification of Birth Abroad (FS 545)',
      abbr: 'Certification of Birth Abroad (FS 545)',
    },
    {
      code: 'DS_1350',
      name: 'Certificate of Report of Birth (DS 1350)',
      abbr: 'Certificate of Report of Birth (DS 1350)',
    },
    {
      code: 'FS_240',
      name: 'Consular Report of Birth Abroad (FS 240)',
      abbr: 'Consular Report of Birth Abroad (FS 240)',
    },
    {
      code: 'US_BIRTH_CERTIFICATE',
      name: 'U.S. birth certificate (original or certified copy)',
      abbr: 'U.S. birth certificate (original or certified copy)',
    },
    {
      code: 'NATIVE_AMERICAN_TRIBAL_DOCUMENT',
      name: 'Native American tribal document',
      abbr: 'Native American tribal document',
    },
    {
      code: 'FORM_I197',
      name: 'U.S. Citizen ID Card (Form I-197)',
      abbr: 'U.S. Citizen ID Card (Form I-197)',
    },
    {
      code: 'FORM_I179',
      name: 'ID Card for Use of Resident Citizen in the United States (Form I-179)',
      abbr: 'ID Card for Use of Resident Citizen in the United States (Form I-179)',
    },
    {
      code: 'EMPLOYMENT_AUTHORIZATION_DOCUMENT',
      name: 'Employment authorization document issued by the U.S. Department of Homeland Security',
      abbr: 'Employment authorization document issued by the U.S. Department of Homeland Security',
    },
  ],
  lawful_permanent_resident: [
    {
      code: 'SOCIAL_SECURITY_CARD',
      name: 'Social Security Card',
      abbr: 'Social Security Card',
    },
    {
      code: 'NATIVE_AMERICAN_TRIBAL_DOCUMENT',
      name: 'Native American tribal document',
      abbr: 'Native American tribal document',
    },
    {
      code: 'EMPLOYMENT_AUTHORIZATION_DOCUMENT',
      name: 'Employment authorization document issued by the U.S. Department of Homeland Security',
      abbr: 'Employment authorization document issued by the U.S. Department of Homeland Security',
    },
  ],
  alien_authorized_to_work: [
    {
      code: 'SOCIAL_SECURITY_CARD',
      name: 'Social Security Card',
      abbr: 'Social Security Card',
    },
    {
      code: 'NATIVE_AMERICAN_TRIBAL_DOCUMENT',
      name: 'Native American tribal document',
      abbr: 'Native American tribal document',
    },
    {
      code: 'EMPLOYMENT_AUTHORIZATION_DOCUMENT',
      name: 'Employment authorization document issued by the U.S. Department of Homeland Security',
      abbr: 'Employment authorization document issued by the U.S. Department of Homeland Security',
    },
  ],
};

export const employeeInfoReviewQuestions = [
  {
    id: 'employee_first_name',
    title: 'First Name',
    question_type: 'short_text',
  },
  {
    id: 'employee_middle_name',
    title: 'Middle Initial',
    question_type: 'short_text',
  },
  {
    id: 'employee_last_name',
    title: 'Last Name',
    question_type: 'short_text',
  },
  {
    id: 'employee_citizenship',
    title: 'Citizenship Status',
    question_type: 'short_text',
  },
];

export const employmentDetailsQuestions = [
  {
    id: 'employee_first_day_of_employment',
    title: 'New hire start date',
    question_type: 'date',
    dateFormat: 'MM/DD/YYYY',
    is_required: true,
  },
];

export const listAQuestions = [
  {
    id: 'list_a_document_title_1',
    title: 'Document Title',
    question_type: 'short_text',
    is_required: true,
  },
  {
    id: 'list_a_issuing_authority_1',
    title: 'Issuing Authority',
    question_type: 'short_text',
    is_required: true,
    options: [
      { codeValue: '1', shortName: 'Authority 1' },
      { codeValue: '2', shortName: 'Authority 2' },
      { codeValue: '3', shortName: 'Authority 3' },
    ],
  },
  {
    id: 'list_a_document_number_1',
    title: 'Document Number',
    question_type: 'short_text',
    is_required: true,
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^[a-zA-Z0-9*-]*$',
      },
    ],
  },
  // Required if user choose FORM I-551
  {
    id: 'i551_number',
    title: 'Document Number',
    question_type: 'short_text',
    placeholder: '3 letters followed by 10 digits.',
    is_required: true,
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^[a-zA-Z]{3}[0-9]{10}$',
      },
    ],
  },
  {
    id: 'list_a_expiration_date_1',
    title: 'Expiration Date',
    question_type: 'date',
    dateFormat: 'MM/DD/YYYY',
  },
  // Required if user provided foreign passport with i94
  {
    id: 'i94_number',
    title: 'I94 Number',
    question_type: 'short_text',
    is_required: true,
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^[0-9A-Za-z]{11}$',
      },
    ],
  },
  // Required if user provided foreign passport
  {
    id: 'country_of_issuance',
    title: 'Country of Issuance',
    is_required: true,
    question_type: 'dropdown',
    options: COUNTRY_OPTIONS,
  },
];

export const listBAndCQuestions = [
  {
    id: 'list_b_document_title_1',
    title: 'Document Title',
    question_type: 'short_text',
    is_required: true,
  },
  // only need state when driver license or state id is used
  {
    id: 'list_b_us_state_code_1',
    title: 'State',
    is_required: true,
    question_type: 'dropdown',
    options: stateOptions,
  },
  {
    id: 'list_b_issuing_authority_1',
    title: 'Issuing Authority',
    question_type: 'short_text',
    is_required: true,
  },
  {
    id: 'list_b_document_number_1',
    title: 'Document Number',
    question_type: 'short_text',
    is_required: true,
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^[a-zA-Z0-9*-]*$',
      },
    ],
  },
  {
    id: 'list_b_expiration_date_1',
    title: 'Expiration Date',
    question_type: 'date',
    dateFormat: 'MM/DD/YYYY',
  },
  {
    id: 'list_c_document_title_1',
    title: 'Document Title',
    question_type: 'short_text',
    is_required: true,
  },
  {
    id: 'list_c_issuing_authority_1',
    title: 'Issuing Authority',
    question_type: 'short_text',
    is_required: true,
  },
  {
    id: 'list_c_document_number_1',
    title: 'Document Number',
    question_type: 'short_text',
    is_required: true,
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^[a-zA-Z0-9*-]*$',
      },
    ],
  },
  {
    id: 'list_c_expiration_date_1',
    title: 'Expiration Date',
    question_type: 'date',
    dateFormat: 'MM/DD/YYYY',
  },
];

export const step3Questions = [
  {
    id: 'employer_title',
    title: 'Title of Employer or Authorized Representative',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'employer_last_name',
    title: 'Last name of Employer or Authorized Representative',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'employer_first_name',
    title: 'First name of Employer or Authorized Representative',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'e_verify_case_creator_name',
    title: 'E-Verify Case creator name (Your name)',
    is_required: true,
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: "^[a-zA-Z'’\\- ]{1,128}$",
      },
    ],
  },
  {
    id: 'e_verify_case_creator_email_address',
    title: 'E-Verify Case creator email (Your email)',
    is_required: true,
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^.+@([a-zA-Z0-9]+(-[a-zA-Z0-9]+)*\.)+[a-zA-Z]{2,}$',
      },
    ],
  },
  {
    id: 'e_verify_case_creator_phone',
    title: 'E-Verify Case creator phone (Your phone number)',
    is_required: true,
    question_type: 'us_telephone',
  },
];
